import React, { FC, useState } from 'react';
import Loader from 'react-loader-spinner';
import InfiniteScroll from 'react-infinite-scroller';
import Styled from './styles';
import useHook from './hook';
import MainWrapper from '../../shared/main-wrapper';
import Chart from './components/chart';
import colors from '../../assets/colors';
import { addSnapAction, getSnapsAction } from '../../store/Snaps/action';
import { useUtils } from '../../core/hooks/useUtils';
import { TextField } from '@mui/material';
import MUIButton from '../../shared/mui-button';
import { MODAL_TYPES, useGlobalModalContext } from '../../shared/global-modal';

type IProps = {};
const loaderSize = 50;

const AskPage: FC<IProps> = () => {
	const {
		state,
		isLoading,
		isLoaded,
		data,
		page = 1,
		totalPages = 1,
	} = useHook();
	const { showModal } = useGlobalModalContext();
	const { isScrolled } = state;
	const hasMore: boolean = page < totalPages;
	const { dispatch } = useUtils();

	const [searchValue, setSearchValue] = useState('');

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		setSearchValue(e.target.value);
	};

	const onAddSnap = () => {
		if (!searchValue.trim()) return;
		dispatch(
			addSnapAction({
				text: searchValue,
				showSuccessModal: () => {
					showModal(MODAL_TYPES.SUCCESS_MODAL, {
						title: 'Snap has been successfully added',
						confirmBtn: 'Continue',
					});
				},
				showFailModal,
			})
		);
	};

	const showFailModal = () => {
		showModal(MODAL_TYPES.FAIL_MODAL, {
			title: 'No Results',
			confirmBtn: 'Okay',
		});
	};

	const renderLoader = () => (
		<div
			style={{
				width: '100%',
				display: 'flex',
				justifyContent: 'center',
				minHeight: 150,
			}}
		>
			<Loader
				type="TailSpin"
				color={colors.blue}
				height={loaderSize}
				width={loaderSize}
			/>
		</div>
	);

	return (
		<MainWrapper>
			<Styled.FixedTitle>
				<Styled.Shadow
					isScrolled={isScrolled}
					style={{ padding: '30px 40px 20px' }}
				>
					<div>
						<Styled.Title text={'Ask'} />
					</div>
					<Styled.SearchWrapper>
						<TextField
							onChange={handleChange}
							value={searchValue}
							size="small"
							sx={{ width: '100%' }}
							inputProps={{
								style: {
									height: '30px',
								},
							}}
							label="Ask for report or insight"
						/>
						<MUIButton title="Submit" callBack={onAddSnap} />
					</Styled.SearchWrapper>
				</Styled.Shadow>
			</Styled.FixedTitle>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					flexDirection: 'column',
					width: '100%',
					padding: '0 40px',
					marginTop: 56,
				}}
			>
				{isLoading && !isLoaded && renderLoader()}
				<InfiniteScroll
					pageStart={0}
					loadMore={() =>
						!isLoading && dispatch(getSnapsAction({ page: page + 1 }))
					}
					hasMore={hasMore}
					threshold={750}
					loader={renderLoader()}
				>
					{data?.map((chart: any, i: number) => (
						<Chart
							key={i + chart.capturedInput}
							item={chart}
							originalName={chart}
						/>
					))}
				</InfiniteScroll>
			</div>
		</MainWrapper>
	);
};

export default AskPage;
